module.exports = __webpack_public_path__ + "r-v3/img/set_quality.895a4caa.svg";